/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AppsImport } from './routes/apps'
import { Route as AccountImport } from './routes/account'
import { Route as ProtectedRouteImport } from './routes/_protected/route'
import { Route as IndexImport } from './routes/index'
import { Route as ContactIndexImport } from './routes/contact/index'
import { Route as SubscriptionsSubscriptionNoImport } from './routes/subscriptions/$subscriptionNo'
import { Route as PaymentPlansPaymentPlanIdImport } from './routes/payment-plans/$paymentPlanId'
import { Route as OrdersOrderNoImport } from './routes/orders/$orderNo'
import { Route as AuthVerifyEmailChangeImport } from './routes/auth/verify-email-change'
import { Route as AuthUpdatePasswordImport } from './routes/auth/update-password'
import { Route as AuthSsoImport } from './routes/auth/sso'
import { Route as AuthResetPasswordImport } from './routes/auth/reset-password'
import { Route as AuthMagicLinkImport } from './routes/auth/magic-link'
import { Route as AuthLoginImport } from './routes/auth/login'
import { Route as AuthForgotPasswordImport } from './routes/auth/forgot-password'
import { Route as AuthCancelEmailChangeImport } from './routes/auth/cancel-email-change'
import { Route as AuthCallbackImport } from './routes/auth/callback'
import { Route as ProtectedProgramsIndexImport } from './routes/_protected/programs/index'
import { Route as ProtectedMediaIndexImport } from './routes/_protected/media/index'
import { Route as ProtectedCommunityHubIndexImport } from './routes/_protected/community-hub/index'
import { Route as ProtectedBillingIndexImport } from './routes/_protected/billing/index'
import { Route as ProtectedProgramsProgramSlugRouteImport } from './routes/_protected/programs/$programSlug/route'
import { Route as ProtectedProgramsProgramSlugIndexImport } from './routes/_protected/programs/$programSlug/index'
import { Route as ProtectedProgramsProgramSlugModuleSlugRouteImport } from './routes/_protected/programs/$programSlug/$moduleSlug/route'
import { Route as ProtectedCommunityHubSpacesIdRouteImport } from './routes/_protected/community-hub/spaces/$id/route'
import { Route as ProtectedProgramsProgramSlugModuleSlugIndexImport } from './routes/_protected/programs/$programSlug/$moduleSlug/index'
import { Route as ProtectedCommunityHubSpacesIdIndexImport } from './routes/_protected/community-hub/spaces/$id/index'
import { Route as ProtectedCommunityHubProgramSlugFeedSlugIndexImport } from './routes/_protected/community-hub/$programSlug/$feedSlug/index'
import { Route as ProtectedProgramsProgramSlugVideoItemSlugImport } from './routes/_protected/programs/$programSlug/video/$itemSlug'
import { Route as ProtectedProgramsProgramSlugTextItemSlugImport } from './routes/_protected/programs/$programSlug/text/$itemSlug'
import { Route as ProtectedProgramsProgramSlugResultsAttemptIdImport } from './routes/_protected/programs/$programSlug/results/$attemptId'
import { Route as ProtectedProgramsProgramSlugQuizItemSlugImport } from './routes/_protected/programs/$programSlug/quiz/$itemSlug'
import { Route as ProtectedProgramsProgramSlugPdfItemSlugImport } from './routes/_protected/programs/$programSlug/pdf/$itemSlug'
import { Route as ProtectedProgramsProgramSlugGcsUploadItemSlugImport } from './routes/_protected/programs/$programSlug/gcs-upload/$itemSlug'
import { Route as ProtectedProgramsProgramSlugFormItemSlugImport } from './routes/_protected/programs/$programSlug/form/$itemSlug'
import { Route as ProtectedProgramsProgramSlugEventItemSlugImport } from './routes/_protected/programs/$programSlug/event/$itemSlug'
import { Route as ProtectedProgramsProgramSlugEmbedItemSlugImport } from './routes/_protected/programs/$programSlug/embed/$itemSlug'
import { Route as ProtectedCommunityHubSpacesIdCommunityImport } from './routes/_protected/community-hub/spaces/$id/community'
import { Route as ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteImport } from './routes/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/route'
import { Route as ProtectedProgramsProgramSlugModuleSlugLessonSlugIndexImport } from './routes/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/index'
import { Route as ProtectedCommunityHubSpacesIdModulesIndexImport } from './routes/_protected/community-hub/spaces/$id/modules/index'
import { Route as ProtectedCommunityHubSpacesIdLessonIndexImport } from './routes/_protected/community-hub/spaces/$id/lesson/index'
import { Route as ProtectedCommunityHubSpacesIdPostsPostIdImport } from './routes/_protected/community-hub/spaces/$id/posts/$postId'
import { Route as ProtectedCommunityHubProgramSlugFeedSlugPostsPostIdImport } from './routes/_protected/community-hub/$programSlug/$feedSlug/posts/$postId'
import { Route as ProtectedCommunityHubSpacesIdModulesModuleIdIndexImport } from './routes/_protected/community-hub/spaces/$id/modules/$moduleId/index'
import { Route as ProtectedProgramsProgramSlugModuleSlugLessonSlugVideoItemSlugImport } from './routes/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/video/$itemSlug'
import { Route as ProtectedProgramsProgramSlugModuleSlugLessonSlugTextItemSlugImport } from './routes/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/text/$itemSlug'
import { Route as ProtectedProgramsProgramSlugModuleSlugLessonSlugResultsAttemptIdImport } from './routes/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/results/$attemptId'
import { Route as ProtectedProgramsProgramSlugModuleSlugLessonSlugQuizItemSlugImport } from './routes/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/quiz/$itemSlug'
import { Route as ProtectedProgramsProgramSlugModuleSlugLessonSlugPdfItemSlugImport } from './routes/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/pdf/$itemSlug'
import { Route as ProtectedProgramsProgramSlugModuleSlugLessonSlugGcsUploadItemSlugImport } from './routes/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/gcs-upload/$itemSlug'
import { Route as ProtectedProgramsProgramSlugModuleSlugLessonSlugFormItemSlugImport } from './routes/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/form/$itemSlug'
import { Route as ProtectedProgramsProgramSlugModuleSlugLessonSlugEventItemSlugImport } from './routes/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/event/$itemSlug'
import { Route as ProtectedProgramsProgramSlugModuleSlugLessonSlugEmbedItemSlugImport } from './routes/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/embed/$itemSlug'
import { Route as ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdIndexImport } from './routes/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/index'
import { Route as ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdVideoContentIdImport } from './routes/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId'
import { Route as ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdTextContentIdImport } from './routes/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId'
import { Route as ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdResultsAttemptIdImport } from './routes/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId'
import { Route as ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdQuizContentIdImport } from './routes/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId'
import { Route as ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdPdfContentIdImport } from './routes/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId'
import { Route as ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdGcsUploadContentIdImport } from './routes/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId'
import { Route as ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdFormContentIdImport } from './routes/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId'
import { Route as ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEventContentIdImport } from './routes/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId'
import { Route as ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEmbedContentIdImport } from './routes/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId'

// Create/Update Routes

const AppsRoute = AppsImport.update({
  id: '/apps',
  path: '/apps',
  getParentRoute: () => rootRoute,
} as any)

const AccountRoute = AccountImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRoute,
} as any)

const ProtectedRouteRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const ContactIndexRoute = ContactIndexImport.update({
  id: '/contact/',
  path: '/contact/',
  getParentRoute: () => rootRoute,
} as any)

const SubscriptionsSubscriptionNoRoute =
  SubscriptionsSubscriptionNoImport.update({
    id: '/subscriptions/$subscriptionNo',
    path: '/subscriptions/$subscriptionNo',
    getParentRoute: () => rootRoute,
  } as any)

const PaymentPlansPaymentPlanIdRoute = PaymentPlansPaymentPlanIdImport.update({
  id: '/payment-plans/$paymentPlanId',
  path: '/payment-plans/$paymentPlanId',
  getParentRoute: () => rootRoute,
} as any)

const OrdersOrderNoRoute = OrdersOrderNoImport.update({
  id: '/orders/$orderNo',
  path: '/orders/$orderNo',
  getParentRoute: () => rootRoute,
} as any)

const AuthVerifyEmailChangeRoute = AuthVerifyEmailChangeImport.update({
  id: '/auth/verify-email-change',
  path: '/auth/verify-email-change',
  getParentRoute: () => rootRoute,
} as any)

const AuthUpdatePasswordRoute = AuthUpdatePasswordImport.update({
  id: '/auth/update-password',
  path: '/auth/update-password',
  getParentRoute: () => rootRoute,
} as any)

const AuthSsoRoute = AuthSsoImport.update({
  id: '/auth/sso',
  path: '/auth/sso',
  getParentRoute: () => rootRoute,
} as any)

const AuthResetPasswordRoute = AuthResetPasswordImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const AuthMagicLinkRoute = AuthMagicLinkImport.update({
  id: '/auth/magic-link',
  path: '/auth/magic-link',
  getParentRoute: () => rootRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRoute,
} as any)

const AuthForgotPasswordRoute = AuthForgotPasswordImport.update({
  id: '/auth/forgot-password',
  path: '/auth/forgot-password',
  getParentRoute: () => rootRoute,
} as any)

const AuthCancelEmailChangeRoute = AuthCancelEmailChangeImport.update({
  id: '/auth/cancel-email-change',
  path: '/auth/cancel-email-change',
  getParentRoute: () => rootRoute,
} as any)

const AuthCallbackRoute = AuthCallbackImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRoute,
} as any)

const ProtectedProgramsIndexRoute = ProtectedProgramsIndexImport.update({
  id: '/programs/',
  path: '/programs/',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

const ProtectedMediaIndexRoute = ProtectedMediaIndexImport.update({
  id: '/media/',
  path: '/media/',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

const ProtectedCommunityHubIndexRoute = ProtectedCommunityHubIndexImport.update(
  {
    id: '/community-hub/',
    path: '/community-hub/',
    getParentRoute: () => ProtectedRouteRoute,
  } as any,
)

const ProtectedBillingIndexRoute = ProtectedBillingIndexImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

const ProtectedProgramsProgramSlugRouteRoute =
  ProtectedProgramsProgramSlugRouteImport.update({
    id: '/programs/$programSlug',
    path: '/programs/$programSlug',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)

const ProtectedProgramsProgramSlugIndexRoute =
  ProtectedProgramsProgramSlugIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedProgramsProgramSlugRouteRoute,
  } as any)

const ProtectedProgramsProgramSlugModuleSlugRouteRoute =
  ProtectedProgramsProgramSlugModuleSlugRouteImport.update({
    id: '/$moduleSlug',
    path: '/$moduleSlug',
    getParentRoute: () => ProtectedProgramsProgramSlugRouteRoute,
  } as any)

const ProtectedCommunityHubSpacesIdRouteRoute =
  ProtectedCommunityHubSpacesIdRouteImport.update({
    id: '/community-hub/spaces/$id',
    path: '/community-hub/spaces/$id',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)

const ProtectedProgramsProgramSlugModuleSlugIndexRoute =
  ProtectedProgramsProgramSlugModuleSlugIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedProgramsProgramSlugModuleSlugRouteRoute,
  } as any)

const ProtectedCommunityHubSpacesIdIndexRoute =
  ProtectedCommunityHubSpacesIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
  } as any)

const ProtectedCommunityHubProgramSlugFeedSlugIndexRoute =
  ProtectedCommunityHubProgramSlugFeedSlugIndexImport.update({
    id: '/community-hub/$programSlug/$feedSlug/',
    path: '/community-hub/$programSlug/$feedSlug/',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)

const ProtectedProgramsProgramSlugVideoItemSlugRoute =
  ProtectedProgramsProgramSlugVideoItemSlugImport.update({
    id: '/video/$itemSlug',
    path: '/video/$itemSlug',
    getParentRoute: () => ProtectedProgramsProgramSlugRouteRoute,
  } as any)

const ProtectedProgramsProgramSlugTextItemSlugRoute =
  ProtectedProgramsProgramSlugTextItemSlugImport.update({
    id: '/text/$itemSlug',
    path: '/text/$itemSlug',
    getParentRoute: () => ProtectedProgramsProgramSlugRouteRoute,
  } as any)

const ProtectedProgramsProgramSlugResultsAttemptIdRoute =
  ProtectedProgramsProgramSlugResultsAttemptIdImport.update({
    id: '/results/$attemptId',
    path: '/results/$attemptId',
    getParentRoute: () => ProtectedProgramsProgramSlugRouteRoute,
  } as any)

const ProtectedProgramsProgramSlugQuizItemSlugRoute =
  ProtectedProgramsProgramSlugQuizItemSlugImport.update({
    id: '/quiz/$itemSlug',
    path: '/quiz/$itemSlug',
    getParentRoute: () => ProtectedProgramsProgramSlugRouteRoute,
  } as any)

const ProtectedProgramsProgramSlugPdfItemSlugRoute =
  ProtectedProgramsProgramSlugPdfItemSlugImport.update({
    id: '/pdf/$itemSlug',
    path: '/pdf/$itemSlug',
    getParentRoute: () => ProtectedProgramsProgramSlugRouteRoute,
  } as any)

const ProtectedProgramsProgramSlugGcsUploadItemSlugRoute =
  ProtectedProgramsProgramSlugGcsUploadItemSlugImport.update({
    id: '/gcs-upload/$itemSlug',
    path: '/gcs-upload/$itemSlug',
    getParentRoute: () => ProtectedProgramsProgramSlugRouteRoute,
  } as any)

const ProtectedProgramsProgramSlugFormItemSlugRoute =
  ProtectedProgramsProgramSlugFormItemSlugImport.update({
    id: '/form/$itemSlug',
    path: '/form/$itemSlug',
    getParentRoute: () => ProtectedProgramsProgramSlugRouteRoute,
  } as any)

const ProtectedProgramsProgramSlugEventItemSlugRoute =
  ProtectedProgramsProgramSlugEventItemSlugImport.update({
    id: '/event/$itemSlug',
    path: '/event/$itemSlug',
    getParentRoute: () => ProtectedProgramsProgramSlugRouteRoute,
  } as any)

const ProtectedProgramsProgramSlugEmbedItemSlugRoute =
  ProtectedProgramsProgramSlugEmbedItemSlugImport.update({
    id: '/embed/$itemSlug',
    path: '/embed/$itemSlug',
    getParentRoute: () => ProtectedProgramsProgramSlugRouteRoute,
  } as any)

const ProtectedCommunityHubSpacesIdCommunityRoute =
  ProtectedCommunityHubSpacesIdCommunityImport.update({
    id: '/community',
    path: '/community',
    getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
  } as any)

const ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteRoute =
  ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteImport.update({
    id: '/$lessonSlug',
    path: '/$lessonSlug',
    getParentRoute: () => ProtectedProgramsProgramSlugModuleSlugRouteRoute,
  } as any)

const ProtectedProgramsProgramSlugModuleSlugLessonSlugIndexRoute =
  ProtectedProgramsProgramSlugModuleSlugLessonSlugIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteRoute,
  } as any)

const ProtectedCommunityHubSpacesIdModulesIndexRoute =
  ProtectedCommunityHubSpacesIdModulesIndexImport.update({
    id: '/modules/',
    path: '/modules/',
    getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
  } as any)

const ProtectedCommunityHubSpacesIdLessonIndexRoute =
  ProtectedCommunityHubSpacesIdLessonIndexImport.update({
    id: '/lesson/',
    path: '/lesson/',
    getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
  } as any)

const ProtectedCommunityHubSpacesIdPostsPostIdRoute =
  ProtectedCommunityHubSpacesIdPostsPostIdImport.update({
    id: '/posts/$postId',
    path: '/posts/$postId',
    getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
  } as any)

const ProtectedCommunityHubProgramSlugFeedSlugPostsPostIdRoute =
  ProtectedCommunityHubProgramSlugFeedSlugPostsPostIdImport.update({
    id: '/community-hub/$programSlug/$feedSlug/posts/$postId',
    path: '/community-hub/$programSlug/$feedSlug/posts/$postId',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)

const ProtectedCommunityHubSpacesIdModulesModuleIdIndexRoute =
  ProtectedCommunityHubSpacesIdModulesModuleIdIndexImport.update({
    id: '/modules/$moduleId/',
    path: '/modules/$moduleId/',
    getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
  } as any)

const ProtectedProgramsProgramSlugModuleSlugLessonSlugVideoItemSlugRoute =
  ProtectedProgramsProgramSlugModuleSlugLessonSlugVideoItemSlugImport.update({
    id: '/video/$itemSlug',
    path: '/video/$itemSlug',
    getParentRoute: () =>
      ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteRoute,
  } as any)

const ProtectedProgramsProgramSlugModuleSlugLessonSlugTextItemSlugRoute =
  ProtectedProgramsProgramSlugModuleSlugLessonSlugTextItemSlugImport.update({
    id: '/text/$itemSlug',
    path: '/text/$itemSlug',
    getParentRoute: () =>
      ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteRoute,
  } as any)

const ProtectedProgramsProgramSlugModuleSlugLessonSlugResultsAttemptIdRoute =
  ProtectedProgramsProgramSlugModuleSlugLessonSlugResultsAttemptIdImport.update(
    {
      id: '/results/$attemptId',
      path: '/results/$attemptId',
      getParentRoute: () =>
        ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteRoute,
    } as any,
  )

const ProtectedProgramsProgramSlugModuleSlugLessonSlugQuizItemSlugRoute =
  ProtectedProgramsProgramSlugModuleSlugLessonSlugQuizItemSlugImport.update({
    id: '/quiz/$itemSlug',
    path: '/quiz/$itemSlug',
    getParentRoute: () =>
      ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteRoute,
  } as any)

const ProtectedProgramsProgramSlugModuleSlugLessonSlugPdfItemSlugRoute =
  ProtectedProgramsProgramSlugModuleSlugLessonSlugPdfItemSlugImport.update({
    id: '/pdf/$itemSlug',
    path: '/pdf/$itemSlug',
    getParentRoute: () =>
      ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteRoute,
  } as any)

const ProtectedProgramsProgramSlugModuleSlugLessonSlugGcsUploadItemSlugRoute =
  ProtectedProgramsProgramSlugModuleSlugLessonSlugGcsUploadItemSlugImport.update(
    {
      id: '/gcs-upload/$itemSlug',
      path: '/gcs-upload/$itemSlug',
      getParentRoute: () =>
        ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteRoute,
    } as any,
  )

const ProtectedProgramsProgramSlugModuleSlugLessonSlugFormItemSlugRoute =
  ProtectedProgramsProgramSlugModuleSlugLessonSlugFormItemSlugImport.update({
    id: '/form/$itemSlug',
    path: '/form/$itemSlug',
    getParentRoute: () =>
      ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteRoute,
  } as any)

const ProtectedProgramsProgramSlugModuleSlugLessonSlugEventItemSlugRoute =
  ProtectedProgramsProgramSlugModuleSlugLessonSlugEventItemSlugImport.update({
    id: '/event/$itemSlug',
    path: '/event/$itemSlug',
    getParentRoute: () =>
      ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteRoute,
  } as any)

const ProtectedProgramsProgramSlugModuleSlugLessonSlugEmbedItemSlugRoute =
  ProtectedProgramsProgramSlugModuleSlugLessonSlugEmbedItemSlugImport.update({
    id: '/embed/$itemSlug',
    path: '/embed/$itemSlug',
    getParentRoute: () =>
      ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteRoute,
  } as any)

const ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdIndexRoute =
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdIndexImport.update(
    {
      id: '/modules/$moduleId/lessons/$lessonId/',
      path: '/modules/$moduleId/lessons/$lessonId/',
      getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
    } as any,
  )

const ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdVideoContentIdRoute =
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdVideoContentIdImport.update(
    {
      id: '/modules/$moduleId/lessons/$lessonId/video/$contentId',
      path: '/modules/$moduleId/lessons/$lessonId/video/$contentId',
      getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
    } as any,
  )

const ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdTextContentIdRoute =
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdTextContentIdImport.update(
    {
      id: '/modules/$moduleId/lessons/$lessonId/text/$contentId',
      path: '/modules/$moduleId/lessons/$lessonId/text/$contentId',
      getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
    } as any,
  )

const ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdResultsAttemptIdRoute =
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdResultsAttemptIdImport.update(
    {
      id: '/modules/$moduleId/lessons/$lessonId/results/$attemptId',
      path: '/modules/$moduleId/lessons/$lessonId/results/$attemptId',
      getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
    } as any,
  )

const ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdQuizContentIdRoute =
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdQuizContentIdImport.update(
    {
      id: '/modules/$moduleId/lessons/$lessonId/quiz/$contentId',
      path: '/modules/$moduleId/lessons/$lessonId/quiz/$contentId',
      getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
    } as any,
  )

const ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdPdfContentIdRoute =
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdPdfContentIdImport.update(
    {
      id: '/modules/$moduleId/lessons/$lessonId/pdf/$contentId',
      path: '/modules/$moduleId/lessons/$lessonId/pdf/$contentId',
      getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
    } as any,
  )

const ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdGcsUploadContentIdRoute =
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdGcsUploadContentIdImport.update(
    {
      id: '/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId',
      path: '/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId',
      getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
    } as any,
  )

const ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdFormContentIdRoute =
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdFormContentIdImport.update(
    {
      id: '/modules/$moduleId/lessons/$lessonId/form/$contentId',
      path: '/modules/$moduleId/lessons/$lessonId/form/$contentId',
      getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
    } as any,
  )

const ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEventContentIdRoute =
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEventContentIdImport.update(
    {
      id: '/modules/$moduleId/lessons/$lessonId/event/$contentId',
      path: '/modules/$moduleId/lessons/$lessonId/event/$contentId',
      getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
    } as any,
  )

const ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEmbedContentIdRoute =
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEmbedContentIdImport.update(
    {
      id: '/modules/$moduleId/lessons/$lessonId/embed/$contentId',
      path: '/modules/$moduleId/lessons/$lessonId/embed/$contentId',
      getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRoute
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountImport
      parentRoute: typeof rootRoute
    }
    '/apps': {
      id: '/apps'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof AppsImport
      parentRoute: typeof rootRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackImport
      parentRoute: typeof rootRoute
    }
    '/auth/cancel-email-change': {
      id: '/auth/cancel-email-change'
      path: '/auth/cancel-email-change'
      fullPath: '/auth/cancel-email-change'
      preLoaderRoute: typeof AuthCancelEmailChangeImport
      parentRoute: typeof rootRoute
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/auth/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordImport
      parentRoute: typeof rootRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof rootRoute
    }
    '/auth/magic-link': {
      id: '/auth/magic-link'
      path: '/auth/magic-link'
      fullPath: '/auth/magic-link'
      preLoaderRoute: typeof AuthMagicLinkImport
      parentRoute: typeof rootRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/auth/sso': {
      id: '/auth/sso'
      path: '/auth/sso'
      fullPath: '/auth/sso'
      preLoaderRoute: typeof AuthSsoImport
      parentRoute: typeof rootRoute
    }
    '/auth/update-password': {
      id: '/auth/update-password'
      path: '/auth/update-password'
      fullPath: '/auth/update-password'
      preLoaderRoute: typeof AuthUpdatePasswordImport
      parentRoute: typeof rootRoute
    }
    '/auth/verify-email-change': {
      id: '/auth/verify-email-change'
      path: '/auth/verify-email-change'
      fullPath: '/auth/verify-email-change'
      preLoaderRoute: typeof AuthVerifyEmailChangeImport
      parentRoute: typeof rootRoute
    }
    '/orders/$orderNo': {
      id: '/orders/$orderNo'
      path: '/orders/$orderNo'
      fullPath: '/orders/$orderNo'
      preLoaderRoute: typeof OrdersOrderNoImport
      parentRoute: typeof rootRoute
    }
    '/payment-plans/$paymentPlanId': {
      id: '/payment-plans/$paymentPlanId'
      path: '/payment-plans/$paymentPlanId'
      fullPath: '/payment-plans/$paymentPlanId'
      preLoaderRoute: typeof PaymentPlansPaymentPlanIdImport
      parentRoute: typeof rootRoute
    }
    '/subscriptions/$subscriptionNo': {
      id: '/subscriptions/$subscriptionNo'
      path: '/subscriptions/$subscriptionNo'
      fullPath: '/subscriptions/$subscriptionNo'
      preLoaderRoute: typeof SubscriptionsSubscriptionNoImport
      parentRoute: typeof rootRoute
    }
    '/contact/': {
      id: '/contact/'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactIndexImport
      parentRoute: typeof rootRoute
    }
    '/_protected/programs/$programSlug': {
      id: '/_protected/programs/$programSlug'
      path: '/programs/$programSlug'
      fullPath: '/programs/$programSlug'
      preLoaderRoute: typeof ProtectedProgramsProgramSlugRouteImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/billing/': {
      id: '/_protected/billing/'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof ProtectedBillingIndexImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/community-hub/': {
      id: '/_protected/community-hub/'
      path: '/community-hub'
      fullPath: '/community-hub'
      preLoaderRoute: typeof ProtectedCommunityHubIndexImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/media/': {
      id: '/_protected/media/'
      path: '/media'
      fullPath: '/media'
      preLoaderRoute: typeof ProtectedMediaIndexImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/programs/': {
      id: '/_protected/programs/'
      path: '/programs'
      fullPath: '/programs'
      preLoaderRoute: typeof ProtectedProgramsIndexImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/community-hub/spaces/$id': {
      id: '/_protected/community-hub/spaces/$id'
      path: '/community-hub/spaces/$id'
      fullPath: '/community-hub/spaces/$id'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/programs/$programSlug/$moduleSlug': {
      id: '/_protected/programs/$programSlug/$moduleSlug'
      path: '/$moduleSlug'
      fullPath: '/programs/$programSlug/$moduleSlug'
      preLoaderRoute: typeof ProtectedProgramsProgramSlugModuleSlugRouteImport
      parentRoute: typeof ProtectedProgramsProgramSlugRouteImport
    }
    '/_protected/programs/$programSlug/': {
      id: '/_protected/programs/$programSlug/'
      path: '/'
      fullPath: '/programs/$programSlug/'
      preLoaderRoute: typeof ProtectedProgramsProgramSlugIndexImport
      parentRoute: typeof ProtectedProgramsProgramSlugRouteImport
    }
    '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug': {
      id: '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug'
      path: '/$lessonSlug'
      fullPath: '/programs/$programSlug/$moduleSlug/$lessonSlug'
      preLoaderRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteImport
      parentRoute: typeof ProtectedProgramsProgramSlugModuleSlugRouteImport
    }
    '/_protected/community-hub/spaces/$id/community': {
      id: '/_protected/community-hub/spaces/$id/community'
      path: '/community'
      fullPath: '/community-hub/spaces/$id/community'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdCommunityImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/programs/$programSlug/embed/$itemSlug': {
      id: '/_protected/programs/$programSlug/embed/$itemSlug'
      path: '/embed/$itemSlug'
      fullPath: '/programs/$programSlug/embed/$itemSlug'
      preLoaderRoute: typeof ProtectedProgramsProgramSlugEmbedItemSlugImport
      parentRoute: typeof ProtectedProgramsProgramSlugRouteImport
    }
    '/_protected/programs/$programSlug/event/$itemSlug': {
      id: '/_protected/programs/$programSlug/event/$itemSlug'
      path: '/event/$itemSlug'
      fullPath: '/programs/$programSlug/event/$itemSlug'
      preLoaderRoute: typeof ProtectedProgramsProgramSlugEventItemSlugImport
      parentRoute: typeof ProtectedProgramsProgramSlugRouteImport
    }
    '/_protected/programs/$programSlug/form/$itemSlug': {
      id: '/_protected/programs/$programSlug/form/$itemSlug'
      path: '/form/$itemSlug'
      fullPath: '/programs/$programSlug/form/$itemSlug'
      preLoaderRoute: typeof ProtectedProgramsProgramSlugFormItemSlugImport
      parentRoute: typeof ProtectedProgramsProgramSlugRouteImport
    }
    '/_protected/programs/$programSlug/gcs-upload/$itemSlug': {
      id: '/_protected/programs/$programSlug/gcs-upload/$itemSlug'
      path: '/gcs-upload/$itemSlug'
      fullPath: '/programs/$programSlug/gcs-upload/$itemSlug'
      preLoaderRoute: typeof ProtectedProgramsProgramSlugGcsUploadItemSlugImport
      parentRoute: typeof ProtectedProgramsProgramSlugRouteImport
    }
    '/_protected/programs/$programSlug/pdf/$itemSlug': {
      id: '/_protected/programs/$programSlug/pdf/$itemSlug'
      path: '/pdf/$itemSlug'
      fullPath: '/programs/$programSlug/pdf/$itemSlug'
      preLoaderRoute: typeof ProtectedProgramsProgramSlugPdfItemSlugImport
      parentRoute: typeof ProtectedProgramsProgramSlugRouteImport
    }
    '/_protected/programs/$programSlug/quiz/$itemSlug': {
      id: '/_protected/programs/$programSlug/quiz/$itemSlug'
      path: '/quiz/$itemSlug'
      fullPath: '/programs/$programSlug/quiz/$itemSlug'
      preLoaderRoute: typeof ProtectedProgramsProgramSlugQuizItemSlugImport
      parentRoute: typeof ProtectedProgramsProgramSlugRouteImport
    }
    '/_protected/programs/$programSlug/results/$attemptId': {
      id: '/_protected/programs/$programSlug/results/$attemptId'
      path: '/results/$attemptId'
      fullPath: '/programs/$programSlug/results/$attemptId'
      preLoaderRoute: typeof ProtectedProgramsProgramSlugResultsAttemptIdImport
      parentRoute: typeof ProtectedProgramsProgramSlugRouteImport
    }
    '/_protected/programs/$programSlug/text/$itemSlug': {
      id: '/_protected/programs/$programSlug/text/$itemSlug'
      path: '/text/$itemSlug'
      fullPath: '/programs/$programSlug/text/$itemSlug'
      preLoaderRoute: typeof ProtectedProgramsProgramSlugTextItemSlugImport
      parentRoute: typeof ProtectedProgramsProgramSlugRouteImport
    }
    '/_protected/programs/$programSlug/video/$itemSlug': {
      id: '/_protected/programs/$programSlug/video/$itemSlug'
      path: '/video/$itemSlug'
      fullPath: '/programs/$programSlug/video/$itemSlug'
      preLoaderRoute: typeof ProtectedProgramsProgramSlugVideoItemSlugImport
      parentRoute: typeof ProtectedProgramsProgramSlugRouteImport
    }
    '/_protected/community-hub/$programSlug/$feedSlug/': {
      id: '/_protected/community-hub/$programSlug/$feedSlug/'
      path: '/community-hub/$programSlug/$feedSlug'
      fullPath: '/community-hub/$programSlug/$feedSlug'
      preLoaderRoute: typeof ProtectedCommunityHubProgramSlugFeedSlugIndexImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/community-hub/spaces/$id/': {
      id: '/_protected/community-hub/spaces/$id/'
      path: '/'
      fullPath: '/community-hub/spaces/$id/'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdIndexImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/programs/$programSlug/$moduleSlug/': {
      id: '/_protected/programs/$programSlug/$moduleSlug/'
      path: '/'
      fullPath: '/programs/$programSlug/$moduleSlug/'
      preLoaderRoute: typeof ProtectedProgramsProgramSlugModuleSlugIndexImport
      parentRoute: typeof ProtectedProgramsProgramSlugModuleSlugRouteImport
    }
    '/_protected/community-hub/$programSlug/$feedSlug/posts/$postId': {
      id: '/_protected/community-hub/$programSlug/$feedSlug/posts/$postId'
      path: '/community-hub/$programSlug/$feedSlug/posts/$postId'
      fullPath: '/community-hub/$programSlug/$feedSlug/posts/$postId'
      preLoaderRoute: typeof ProtectedCommunityHubProgramSlugFeedSlugPostsPostIdImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/community-hub/spaces/$id/posts/$postId': {
      id: '/_protected/community-hub/spaces/$id/posts/$postId'
      path: '/posts/$postId'
      fullPath: '/community-hub/spaces/$id/posts/$postId'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdPostsPostIdImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/lesson/': {
      id: '/_protected/community-hub/spaces/$id/lesson/'
      path: '/lesson'
      fullPath: '/community-hub/spaces/$id/lesson'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdLessonIndexImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/modules/': {
      id: '/_protected/community-hub/spaces/$id/modules/'
      path: '/modules'
      fullPath: '/community-hub/spaces/$id/modules'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdModulesIndexImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/': {
      id: '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/'
      path: '/'
      fullPath: '/programs/$programSlug/$moduleSlug/$lessonSlug/'
      preLoaderRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugIndexImport
      parentRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteImport
    }
    '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/embed/$itemSlug': {
      id: '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/embed/$itemSlug'
      path: '/embed/$itemSlug'
      fullPath: '/programs/$programSlug/$moduleSlug/$lessonSlug/embed/$itemSlug'
      preLoaderRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugEmbedItemSlugImport
      parentRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteImport
    }
    '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/event/$itemSlug': {
      id: '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/event/$itemSlug'
      path: '/event/$itemSlug'
      fullPath: '/programs/$programSlug/$moduleSlug/$lessonSlug/event/$itemSlug'
      preLoaderRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugEventItemSlugImport
      parentRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteImport
    }
    '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/form/$itemSlug': {
      id: '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/form/$itemSlug'
      path: '/form/$itemSlug'
      fullPath: '/programs/$programSlug/$moduleSlug/$lessonSlug/form/$itemSlug'
      preLoaderRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugFormItemSlugImport
      parentRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteImport
    }
    '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/gcs-upload/$itemSlug': {
      id: '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/gcs-upload/$itemSlug'
      path: '/gcs-upload/$itemSlug'
      fullPath: '/programs/$programSlug/$moduleSlug/$lessonSlug/gcs-upload/$itemSlug'
      preLoaderRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugGcsUploadItemSlugImport
      parentRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteImport
    }
    '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/pdf/$itemSlug': {
      id: '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/pdf/$itemSlug'
      path: '/pdf/$itemSlug'
      fullPath: '/programs/$programSlug/$moduleSlug/$lessonSlug/pdf/$itemSlug'
      preLoaderRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugPdfItemSlugImport
      parentRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteImport
    }
    '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/quiz/$itemSlug': {
      id: '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/quiz/$itemSlug'
      path: '/quiz/$itemSlug'
      fullPath: '/programs/$programSlug/$moduleSlug/$lessonSlug/quiz/$itemSlug'
      preLoaderRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugQuizItemSlugImport
      parentRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteImport
    }
    '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/results/$attemptId': {
      id: '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/results/$attemptId'
      path: '/results/$attemptId'
      fullPath: '/programs/$programSlug/$moduleSlug/$lessonSlug/results/$attemptId'
      preLoaderRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugResultsAttemptIdImport
      parentRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteImport
    }
    '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/text/$itemSlug': {
      id: '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/text/$itemSlug'
      path: '/text/$itemSlug'
      fullPath: '/programs/$programSlug/$moduleSlug/$lessonSlug/text/$itemSlug'
      preLoaderRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugTextItemSlugImport
      parentRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteImport
    }
    '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/video/$itemSlug': {
      id: '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/video/$itemSlug'
      path: '/video/$itemSlug'
      fullPath: '/programs/$programSlug/$moduleSlug/$lessonSlug/video/$itemSlug'
      preLoaderRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugVideoItemSlugImport
      parentRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteImport
    }
    '/_protected/community-hub/spaces/$id/modules/$moduleId/': {
      id: '/_protected/community-hub/spaces/$id/modules/$moduleId/'
      path: '/modules/$moduleId'
      fullPath: '/community-hub/spaces/$id/modules/$moduleId'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdIndexImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/': {
      id: '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/'
      path: '/modules/$moduleId/lessons/$lessonId'
      fullPath: '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdIndexImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId': {
      id: '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId'
      path: '/modules/$moduleId/lessons/$lessonId/embed/$contentId'
      fullPath: '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEmbedContentIdImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId': {
      id: '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId'
      path: '/modules/$moduleId/lessons/$lessonId/event/$contentId'
      fullPath: '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEventContentIdImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId': {
      id: '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId'
      path: '/modules/$moduleId/lessons/$lessonId/form/$contentId'
      fullPath: '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdFormContentIdImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId': {
      id: '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId'
      path: '/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId'
      fullPath: '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdGcsUploadContentIdImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId': {
      id: '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId'
      path: '/modules/$moduleId/lessons/$lessonId/pdf/$contentId'
      fullPath: '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdPdfContentIdImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId': {
      id: '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId'
      path: '/modules/$moduleId/lessons/$lessonId/quiz/$contentId'
      fullPath: '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdQuizContentIdImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId': {
      id: '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId'
      path: '/modules/$moduleId/lessons/$lessonId/results/$attemptId'
      fullPath: '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdResultsAttemptIdImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId': {
      id: '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId'
      path: '/modules/$moduleId/lessons/$lessonId/text/$contentId'
      fullPath: '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdTextContentIdImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId': {
      id: '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId'
      path: '/modules/$moduleId/lessons/$lessonId/video/$contentId'
      fullPath: '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdVideoContentIdImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
  }
}

// Create and export the route tree

interface ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteRouteChildren {
  ProtectedProgramsProgramSlugModuleSlugLessonSlugIndexRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugIndexRoute
  ProtectedProgramsProgramSlugModuleSlugLessonSlugEmbedItemSlugRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugEmbedItemSlugRoute
  ProtectedProgramsProgramSlugModuleSlugLessonSlugEventItemSlugRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugEventItemSlugRoute
  ProtectedProgramsProgramSlugModuleSlugLessonSlugFormItemSlugRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugFormItemSlugRoute
  ProtectedProgramsProgramSlugModuleSlugLessonSlugGcsUploadItemSlugRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugGcsUploadItemSlugRoute
  ProtectedProgramsProgramSlugModuleSlugLessonSlugPdfItemSlugRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugPdfItemSlugRoute
  ProtectedProgramsProgramSlugModuleSlugLessonSlugQuizItemSlugRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugQuizItemSlugRoute
  ProtectedProgramsProgramSlugModuleSlugLessonSlugResultsAttemptIdRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugResultsAttemptIdRoute
  ProtectedProgramsProgramSlugModuleSlugLessonSlugTextItemSlugRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugTextItemSlugRoute
  ProtectedProgramsProgramSlugModuleSlugLessonSlugVideoItemSlugRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugVideoItemSlugRoute
}

const ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteRouteChildren: ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteRouteChildren =
  {
    ProtectedProgramsProgramSlugModuleSlugLessonSlugIndexRoute:
      ProtectedProgramsProgramSlugModuleSlugLessonSlugIndexRoute,
    ProtectedProgramsProgramSlugModuleSlugLessonSlugEmbedItemSlugRoute:
      ProtectedProgramsProgramSlugModuleSlugLessonSlugEmbedItemSlugRoute,
    ProtectedProgramsProgramSlugModuleSlugLessonSlugEventItemSlugRoute:
      ProtectedProgramsProgramSlugModuleSlugLessonSlugEventItemSlugRoute,
    ProtectedProgramsProgramSlugModuleSlugLessonSlugFormItemSlugRoute:
      ProtectedProgramsProgramSlugModuleSlugLessonSlugFormItemSlugRoute,
    ProtectedProgramsProgramSlugModuleSlugLessonSlugGcsUploadItemSlugRoute:
      ProtectedProgramsProgramSlugModuleSlugLessonSlugGcsUploadItemSlugRoute,
    ProtectedProgramsProgramSlugModuleSlugLessonSlugPdfItemSlugRoute:
      ProtectedProgramsProgramSlugModuleSlugLessonSlugPdfItemSlugRoute,
    ProtectedProgramsProgramSlugModuleSlugLessonSlugQuizItemSlugRoute:
      ProtectedProgramsProgramSlugModuleSlugLessonSlugQuizItemSlugRoute,
    ProtectedProgramsProgramSlugModuleSlugLessonSlugResultsAttemptIdRoute:
      ProtectedProgramsProgramSlugModuleSlugLessonSlugResultsAttemptIdRoute,
    ProtectedProgramsProgramSlugModuleSlugLessonSlugTextItemSlugRoute:
      ProtectedProgramsProgramSlugModuleSlugLessonSlugTextItemSlugRoute,
    ProtectedProgramsProgramSlugModuleSlugLessonSlugVideoItemSlugRoute:
      ProtectedProgramsProgramSlugModuleSlugLessonSlugVideoItemSlugRoute,
  }

const ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteRouteWithChildren =
  ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteRoute._addFileChildren(
    ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteRouteChildren,
  )

interface ProtectedProgramsProgramSlugModuleSlugRouteRouteChildren {
  ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteRoute: typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteRouteWithChildren
  ProtectedProgramsProgramSlugModuleSlugIndexRoute: typeof ProtectedProgramsProgramSlugModuleSlugIndexRoute
}

const ProtectedProgramsProgramSlugModuleSlugRouteRouteChildren: ProtectedProgramsProgramSlugModuleSlugRouteRouteChildren =
  {
    ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteRoute:
      ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteRouteWithChildren,
    ProtectedProgramsProgramSlugModuleSlugIndexRoute:
      ProtectedProgramsProgramSlugModuleSlugIndexRoute,
  }

const ProtectedProgramsProgramSlugModuleSlugRouteRouteWithChildren =
  ProtectedProgramsProgramSlugModuleSlugRouteRoute._addFileChildren(
    ProtectedProgramsProgramSlugModuleSlugRouteRouteChildren,
  )

interface ProtectedProgramsProgramSlugRouteRouteChildren {
  ProtectedProgramsProgramSlugModuleSlugRouteRoute: typeof ProtectedProgramsProgramSlugModuleSlugRouteRouteWithChildren
  ProtectedProgramsProgramSlugIndexRoute: typeof ProtectedProgramsProgramSlugIndexRoute
  ProtectedProgramsProgramSlugEmbedItemSlugRoute: typeof ProtectedProgramsProgramSlugEmbedItemSlugRoute
  ProtectedProgramsProgramSlugEventItemSlugRoute: typeof ProtectedProgramsProgramSlugEventItemSlugRoute
  ProtectedProgramsProgramSlugFormItemSlugRoute: typeof ProtectedProgramsProgramSlugFormItemSlugRoute
  ProtectedProgramsProgramSlugGcsUploadItemSlugRoute: typeof ProtectedProgramsProgramSlugGcsUploadItemSlugRoute
  ProtectedProgramsProgramSlugPdfItemSlugRoute: typeof ProtectedProgramsProgramSlugPdfItemSlugRoute
  ProtectedProgramsProgramSlugQuizItemSlugRoute: typeof ProtectedProgramsProgramSlugQuizItemSlugRoute
  ProtectedProgramsProgramSlugResultsAttemptIdRoute: typeof ProtectedProgramsProgramSlugResultsAttemptIdRoute
  ProtectedProgramsProgramSlugTextItemSlugRoute: typeof ProtectedProgramsProgramSlugTextItemSlugRoute
  ProtectedProgramsProgramSlugVideoItemSlugRoute: typeof ProtectedProgramsProgramSlugVideoItemSlugRoute
}

const ProtectedProgramsProgramSlugRouteRouteChildren: ProtectedProgramsProgramSlugRouteRouteChildren =
  {
    ProtectedProgramsProgramSlugModuleSlugRouteRoute:
      ProtectedProgramsProgramSlugModuleSlugRouteRouteWithChildren,
    ProtectedProgramsProgramSlugIndexRoute:
      ProtectedProgramsProgramSlugIndexRoute,
    ProtectedProgramsProgramSlugEmbedItemSlugRoute:
      ProtectedProgramsProgramSlugEmbedItemSlugRoute,
    ProtectedProgramsProgramSlugEventItemSlugRoute:
      ProtectedProgramsProgramSlugEventItemSlugRoute,
    ProtectedProgramsProgramSlugFormItemSlugRoute:
      ProtectedProgramsProgramSlugFormItemSlugRoute,
    ProtectedProgramsProgramSlugGcsUploadItemSlugRoute:
      ProtectedProgramsProgramSlugGcsUploadItemSlugRoute,
    ProtectedProgramsProgramSlugPdfItemSlugRoute:
      ProtectedProgramsProgramSlugPdfItemSlugRoute,
    ProtectedProgramsProgramSlugQuizItemSlugRoute:
      ProtectedProgramsProgramSlugQuizItemSlugRoute,
    ProtectedProgramsProgramSlugResultsAttemptIdRoute:
      ProtectedProgramsProgramSlugResultsAttemptIdRoute,
    ProtectedProgramsProgramSlugTextItemSlugRoute:
      ProtectedProgramsProgramSlugTextItemSlugRoute,
    ProtectedProgramsProgramSlugVideoItemSlugRoute:
      ProtectedProgramsProgramSlugVideoItemSlugRoute,
  }

const ProtectedProgramsProgramSlugRouteRouteWithChildren =
  ProtectedProgramsProgramSlugRouteRoute._addFileChildren(
    ProtectedProgramsProgramSlugRouteRouteChildren,
  )

interface ProtectedCommunityHubSpacesIdRouteRouteChildren {
  ProtectedCommunityHubSpacesIdCommunityRoute: typeof ProtectedCommunityHubSpacesIdCommunityRoute
  ProtectedCommunityHubSpacesIdIndexRoute: typeof ProtectedCommunityHubSpacesIdIndexRoute
  ProtectedCommunityHubSpacesIdPostsPostIdRoute: typeof ProtectedCommunityHubSpacesIdPostsPostIdRoute
  ProtectedCommunityHubSpacesIdLessonIndexRoute: typeof ProtectedCommunityHubSpacesIdLessonIndexRoute
  ProtectedCommunityHubSpacesIdModulesIndexRoute: typeof ProtectedCommunityHubSpacesIdModulesIndexRoute
  ProtectedCommunityHubSpacesIdModulesModuleIdIndexRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdIndexRoute
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdIndexRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdIndexRoute
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEmbedContentIdRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEmbedContentIdRoute
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEventContentIdRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEventContentIdRoute
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdFormContentIdRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdFormContentIdRoute
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdGcsUploadContentIdRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdGcsUploadContentIdRoute
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdPdfContentIdRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdPdfContentIdRoute
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdQuizContentIdRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdQuizContentIdRoute
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdResultsAttemptIdRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdResultsAttemptIdRoute
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdTextContentIdRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdTextContentIdRoute
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdVideoContentIdRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdVideoContentIdRoute
}

const ProtectedCommunityHubSpacesIdRouteRouteChildren: ProtectedCommunityHubSpacesIdRouteRouteChildren =
  {
    ProtectedCommunityHubSpacesIdCommunityRoute:
      ProtectedCommunityHubSpacesIdCommunityRoute,
    ProtectedCommunityHubSpacesIdIndexRoute:
      ProtectedCommunityHubSpacesIdIndexRoute,
    ProtectedCommunityHubSpacesIdPostsPostIdRoute:
      ProtectedCommunityHubSpacesIdPostsPostIdRoute,
    ProtectedCommunityHubSpacesIdLessonIndexRoute:
      ProtectedCommunityHubSpacesIdLessonIndexRoute,
    ProtectedCommunityHubSpacesIdModulesIndexRoute:
      ProtectedCommunityHubSpacesIdModulesIndexRoute,
    ProtectedCommunityHubSpacesIdModulesModuleIdIndexRoute:
      ProtectedCommunityHubSpacesIdModulesModuleIdIndexRoute,
    ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdIndexRoute:
      ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdIndexRoute,
    ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEmbedContentIdRoute:
      ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEmbedContentIdRoute,
    ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEventContentIdRoute:
      ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEventContentIdRoute,
    ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdFormContentIdRoute:
      ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdFormContentIdRoute,
    ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdGcsUploadContentIdRoute:
      ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdGcsUploadContentIdRoute,
    ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdPdfContentIdRoute:
      ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdPdfContentIdRoute,
    ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdQuizContentIdRoute:
      ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdQuizContentIdRoute,
    ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdResultsAttemptIdRoute:
      ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdResultsAttemptIdRoute,
    ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdTextContentIdRoute:
      ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdTextContentIdRoute,
    ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdVideoContentIdRoute:
      ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdVideoContentIdRoute,
  }

const ProtectedCommunityHubSpacesIdRouteRouteWithChildren =
  ProtectedCommunityHubSpacesIdRouteRoute._addFileChildren(
    ProtectedCommunityHubSpacesIdRouteRouteChildren,
  )

interface ProtectedRouteRouteChildren {
  ProtectedProgramsProgramSlugRouteRoute: typeof ProtectedProgramsProgramSlugRouteRouteWithChildren
  ProtectedBillingIndexRoute: typeof ProtectedBillingIndexRoute
  ProtectedCommunityHubIndexRoute: typeof ProtectedCommunityHubIndexRoute
  ProtectedMediaIndexRoute: typeof ProtectedMediaIndexRoute
  ProtectedProgramsIndexRoute: typeof ProtectedProgramsIndexRoute
  ProtectedCommunityHubSpacesIdRouteRoute: typeof ProtectedCommunityHubSpacesIdRouteRouteWithChildren
  ProtectedCommunityHubProgramSlugFeedSlugIndexRoute: typeof ProtectedCommunityHubProgramSlugFeedSlugIndexRoute
  ProtectedCommunityHubProgramSlugFeedSlugPostsPostIdRoute: typeof ProtectedCommunityHubProgramSlugFeedSlugPostsPostIdRoute
}

const ProtectedRouteRouteChildren: ProtectedRouteRouteChildren = {
  ProtectedProgramsProgramSlugRouteRoute:
    ProtectedProgramsProgramSlugRouteRouteWithChildren,
  ProtectedBillingIndexRoute: ProtectedBillingIndexRoute,
  ProtectedCommunityHubIndexRoute: ProtectedCommunityHubIndexRoute,
  ProtectedMediaIndexRoute: ProtectedMediaIndexRoute,
  ProtectedProgramsIndexRoute: ProtectedProgramsIndexRoute,
  ProtectedCommunityHubSpacesIdRouteRoute:
    ProtectedCommunityHubSpacesIdRouteRouteWithChildren,
  ProtectedCommunityHubProgramSlugFeedSlugIndexRoute:
    ProtectedCommunityHubProgramSlugFeedSlugIndexRoute,
  ProtectedCommunityHubProgramSlugFeedSlugPostsPostIdRoute:
    ProtectedCommunityHubProgramSlugFeedSlugPostsPostIdRoute,
}

const ProtectedRouteRouteWithChildren = ProtectedRouteRoute._addFileChildren(
  ProtectedRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof ProtectedRouteRouteWithChildren
  '/account': typeof AccountRoute
  '/apps': typeof AppsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/cancel-email-change': typeof AuthCancelEmailChangeRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/magic-link': typeof AuthMagicLinkRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sso': typeof AuthSsoRoute
  '/auth/update-password': typeof AuthUpdatePasswordRoute
  '/auth/verify-email-change': typeof AuthVerifyEmailChangeRoute
  '/orders/$orderNo': typeof OrdersOrderNoRoute
  '/payment-plans/$paymentPlanId': typeof PaymentPlansPaymentPlanIdRoute
  '/subscriptions/$subscriptionNo': typeof SubscriptionsSubscriptionNoRoute
  '/contact': typeof ContactIndexRoute
  '/programs/$programSlug': typeof ProtectedProgramsProgramSlugRouteRouteWithChildren
  '/billing': typeof ProtectedBillingIndexRoute
  '/community-hub': typeof ProtectedCommunityHubIndexRoute
  '/media': typeof ProtectedMediaIndexRoute
  '/programs': typeof ProtectedProgramsIndexRoute
  '/community-hub/spaces/$id': typeof ProtectedCommunityHubSpacesIdRouteRouteWithChildren
  '/programs/$programSlug/$moduleSlug': typeof ProtectedProgramsProgramSlugModuleSlugRouteRouteWithChildren
  '/programs/$programSlug/': typeof ProtectedProgramsProgramSlugIndexRoute
  '/programs/$programSlug/$moduleSlug/$lessonSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteRouteWithChildren
  '/community-hub/spaces/$id/community': typeof ProtectedCommunityHubSpacesIdCommunityRoute
  '/programs/$programSlug/embed/$itemSlug': typeof ProtectedProgramsProgramSlugEmbedItemSlugRoute
  '/programs/$programSlug/event/$itemSlug': typeof ProtectedProgramsProgramSlugEventItemSlugRoute
  '/programs/$programSlug/form/$itemSlug': typeof ProtectedProgramsProgramSlugFormItemSlugRoute
  '/programs/$programSlug/gcs-upload/$itemSlug': typeof ProtectedProgramsProgramSlugGcsUploadItemSlugRoute
  '/programs/$programSlug/pdf/$itemSlug': typeof ProtectedProgramsProgramSlugPdfItemSlugRoute
  '/programs/$programSlug/quiz/$itemSlug': typeof ProtectedProgramsProgramSlugQuizItemSlugRoute
  '/programs/$programSlug/results/$attemptId': typeof ProtectedProgramsProgramSlugResultsAttemptIdRoute
  '/programs/$programSlug/text/$itemSlug': typeof ProtectedProgramsProgramSlugTextItemSlugRoute
  '/programs/$programSlug/video/$itemSlug': typeof ProtectedProgramsProgramSlugVideoItemSlugRoute
  '/community-hub/$programSlug/$feedSlug': typeof ProtectedCommunityHubProgramSlugFeedSlugIndexRoute
  '/community-hub/spaces/$id/': typeof ProtectedCommunityHubSpacesIdIndexRoute
  '/programs/$programSlug/$moduleSlug/': typeof ProtectedProgramsProgramSlugModuleSlugIndexRoute
  '/community-hub/$programSlug/$feedSlug/posts/$postId': typeof ProtectedCommunityHubProgramSlugFeedSlugPostsPostIdRoute
  '/community-hub/spaces/$id/posts/$postId': typeof ProtectedCommunityHubSpacesIdPostsPostIdRoute
  '/community-hub/spaces/$id/lesson': typeof ProtectedCommunityHubSpacesIdLessonIndexRoute
  '/community-hub/spaces/$id/modules': typeof ProtectedCommunityHubSpacesIdModulesIndexRoute
  '/programs/$programSlug/$moduleSlug/$lessonSlug/': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugIndexRoute
  '/programs/$programSlug/$moduleSlug/$lessonSlug/embed/$itemSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugEmbedItemSlugRoute
  '/programs/$programSlug/$moduleSlug/$lessonSlug/event/$itemSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugEventItemSlugRoute
  '/programs/$programSlug/$moduleSlug/$lessonSlug/form/$itemSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugFormItemSlugRoute
  '/programs/$programSlug/$moduleSlug/$lessonSlug/gcs-upload/$itemSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugGcsUploadItemSlugRoute
  '/programs/$programSlug/$moduleSlug/$lessonSlug/pdf/$itemSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugPdfItemSlugRoute
  '/programs/$programSlug/$moduleSlug/$lessonSlug/quiz/$itemSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugQuizItemSlugRoute
  '/programs/$programSlug/$moduleSlug/$lessonSlug/results/$attemptId': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugResultsAttemptIdRoute
  '/programs/$programSlug/$moduleSlug/$lessonSlug/text/$itemSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugTextItemSlugRoute
  '/programs/$programSlug/$moduleSlug/$lessonSlug/video/$itemSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugVideoItemSlugRoute
  '/community-hub/spaces/$id/modules/$moduleId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdIndexRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdIndexRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEmbedContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEventContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdFormContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdGcsUploadContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdPdfContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdQuizContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdResultsAttemptIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdTextContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdVideoContentIdRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof ProtectedRouteRouteWithChildren
  '/account': typeof AccountRoute
  '/apps': typeof AppsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/cancel-email-change': typeof AuthCancelEmailChangeRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/magic-link': typeof AuthMagicLinkRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sso': typeof AuthSsoRoute
  '/auth/update-password': typeof AuthUpdatePasswordRoute
  '/auth/verify-email-change': typeof AuthVerifyEmailChangeRoute
  '/orders/$orderNo': typeof OrdersOrderNoRoute
  '/payment-plans/$paymentPlanId': typeof PaymentPlansPaymentPlanIdRoute
  '/subscriptions/$subscriptionNo': typeof SubscriptionsSubscriptionNoRoute
  '/contact': typeof ContactIndexRoute
  '/billing': typeof ProtectedBillingIndexRoute
  '/community-hub': typeof ProtectedCommunityHubIndexRoute
  '/media': typeof ProtectedMediaIndexRoute
  '/programs': typeof ProtectedProgramsIndexRoute
  '/programs/$programSlug': typeof ProtectedProgramsProgramSlugIndexRoute
  '/community-hub/spaces/$id/community': typeof ProtectedCommunityHubSpacesIdCommunityRoute
  '/programs/$programSlug/embed/$itemSlug': typeof ProtectedProgramsProgramSlugEmbedItemSlugRoute
  '/programs/$programSlug/event/$itemSlug': typeof ProtectedProgramsProgramSlugEventItemSlugRoute
  '/programs/$programSlug/form/$itemSlug': typeof ProtectedProgramsProgramSlugFormItemSlugRoute
  '/programs/$programSlug/gcs-upload/$itemSlug': typeof ProtectedProgramsProgramSlugGcsUploadItemSlugRoute
  '/programs/$programSlug/pdf/$itemSlug': typeof ProtectedProgramsProgramSlugPdfItemSlugRoute
  '/programs/$programSlug/quiz/$itemSlug': typeof ProtectedProgramsProgramSlugQuizItemSlugRoute
  '/programs/$programSlug/results/$attemptId': typeof ProtectedProgramsProgramSlugResultsAttemptIdRoute
  '/programs/$programSlug/text/$itemSlug': typeof ProtectedProgramsProgramSlugTextItemSlugRoute
  '/programs/$programSlug/video/$itemSlug': typeof ProtectedProgramsProgramSlugVideoItemSlugRoute
  '/community-hub/$programSlug/$feedSlug': typeof ProtectedCommunityHubProgramSlugFeedSlugIndexRoute
  '/community-hub/spaces/$id': typeof ProtectedCommunityHubSpacesIdIndexRoute
  '/programs/$programSlug/$moduleSlug': typeof ProtectedProgramsProgramSlugModuleSlugIndexRoute
  '/community-hub/$programSlug/$feedSlug/posts/$postId': typeof ProtectedCommunityHubProgramSlugFeedSlugPostsPostIdRoute
  '/community-hub/spaces/$id/posts/$postId': typeof ProtectedCommunityHubSpacesIdPostsPostIdRoute
  '/community-hub/spaces/$id/lesson': typeof ProtectedCommunityHubSpacesIdLessonIndexRoute
  '/community-hub/spaces/$id/modules': typeof ProtectedCommunityHubSpacesIdModulesIndexRoute
  '/programs/$programSlug/$moduleSlug/$lessonSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugIndexRoute
  '/programs/$programSlug/$moduleSlug/$lessonSlug/embed/$itemSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugEmbedItemSlugRoute
  '/programs/$programSlug/$moduleSlug/$lessonSlug/event/$itemSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugEventItemSlugRoute
  '/programs/$programSlug/$moduleSlug/$lessonSlug/form/$itemSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugFormItemSlugRoute
  '/programs/$programSlug/$moduleSlug/$lessonSlug/gcs-upload/$itemSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugGcsUploadItemSlugRoute
  '/programs/$programSlug/$moduleSlug/$lessonSlug/pdf/$itemSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugPdfItemSlugRoute
  '/programs/$programSlug/$moduleSlug/$lessonSlug/quiz/$itemSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugQuizItemSlugRoute
  '/programs/$programSlug/$moduleSlug/$lessonSlug/results/$attemptId': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugResultsAttemptIdRoute
  '/programs/$programSlug/$moduleSlug/$lessonSlug/text/$itemSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugTextItemSlugRoute
  '/programs/$programSlug/$moduleSlug/$lessonSlug/video/$itemSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugVideoItemSlugRoute
  '/community-hub/spaces/$id/modules/$moduleId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdIndexRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdIndexRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEmbedContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEventContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdFormContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdGcsUploadContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdPdfContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdQuizContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdResultsAttemptIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdTextContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdVideoContentIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_protected': typeof ProtectedRouteRouteWithChildren
  '/account': typeof AccountRoute
  '/apps': typeof AppsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/cancel-email-change': typeof AuthCancelEmailChangeRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/magic-link': typeof AuthMagicLinkRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sso': typeof AuthSsoRoute
  '/auth/update-password': typeof AuthUpdatePasswordRoute
  '/auth/verify-email-change': typeof AuthVerifyEmailChangeRoute
  '/orders/$orderNo': typeof OrdersOrderNoRoute
  '/payment-plans/$paymentPlanId': typeof PaymentPlansPaymentPlanIdRoute
  '/subscriptions/$subscriptionNo': typeof SubscriptionsSubscriptionNoRoute
  '/contact/': typeof ContactIndexRoute
  '/_protected/programs/$programSlug': typeof ProtectedProgramsProgramSlugRouteRouteWithChildren
  '/_protected/billing/': typeof ProtectedBillingIndexRoute
  '/_protected/community-hub/': typeof ProtectedCommunityHubIndexRoute
  '/_protected/media/': typeof ProtectedMediaIndexRoute
  '/_protected/programs/': typeof ProtectedProgramsIndexRoute
  '/_protected/community-hub/spaces/$id': typeof ProtectedCommunityHubSpacesIdRouteRouteWithChildren
  '/_protected/programs/$programSlug/$moduleSlug': typeof ProtectedProgramsProgramSlugModuleSlugRouteRouteWithChildren
  '/_protected/programs/$programSlug/': typeof ProtectedProgramsProgramSlugIndexRoute
  '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugRouteRouteWithChildren
  '/_protected/community-hub/spaces/$id/community': typeof ProtectedCommunityHubSpacesIdCommunityRoute
  '/_protected/programs/$programSlug/embed/$itemSlug': typeof ProtectedProgramsProgramSlugEmbedItemSlugRoute
  '/_protected/programs/$programSlug/event/$itemSlug': typeof ProtectedProgramsProgramSlugEventItemSlugRoute
  '/_protected/programs/$programSlug/form/$itemSlug': typeof ProtectedProgramsProgramSlugFormItemSlugRoute
  '/_protected/programs/$programSlug/gcs-upload/$itemSlug': typeof ProtectedProgramsProgramSlugGcsUploadItemSlugRoute
  '/_protected/programs/$programSlug/pdf/$itemSlug': typeof ProtectedProgramsProgramSlugPdfItemSlugRoute
  '/_protected/programs/$programSlug/quiz/$itemSlug': typeof ProtectedProgramsProgramSlugQuizItemSlugRoute
  '/_protected/programs/$programSlug/results/$attemptId': typeof ProtectedProgramsProgramSlugResultsAttemptIdRoute
  '/_protected/programs/$programSlug/text/$itemSlug': typeof ProtectedProgramsProgramSlugTextItemSlugRoute
  '/_protected/programs/$programSlug/video/$itemSlug': typeof ProtectedProgramsProgramSlugVideoItemSlugRoute
  '/_protected/community-hub/$programSlug/$feedSlug/': typeof ProtectedCommunityHubProgramSlugFeedSlugIndexRoute
  '/_protected/community-hub/spaces/$id/': typeof ProtectedCommunityHubSpacesIdIndexRoute
  '/_protected/programs/$programSlug/$moduleSlug/': typeof ProtectedProgramsProgramSlugModuleSlugIndexRoute
  '/_protected/community-hub/$programSlug/$feedSlug/posts/$postId': typeof ProtectedCommunityHubProgramSlugFeedSlugPostsPostIdRoute
  '/_protected/community-hub/spaces/$id/posts/$postId': typeof ProtectedCommunityHubSpacesIdPostsPostIdRoute
  '/_protected/community-hub/spaces/$id/lesson/': typeof ProtectedCommunityHubSpacesIdLessonIndexRoute
  '/_protected/community-hub/spaces/$id/modules/': typeof ProtectedCommunityHubSpacesIdModulesIndexRoute
  '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugIndexRoute
  '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/embed/$itemSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugEmbedItemSlugRoute
  '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/event/$itemSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugEventItemSlugRoute
  '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/form/$itemSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugFormItemSlugRoute
  '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/gcs-upload/$itemSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugGcsUploadItemSlugRoute
  '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/pdf/$itemSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugPdfItemSlugRoute
  '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/quiz/$itemSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugQuizItemSlugRoute
  '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/results/$attemptId': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugResultsAttemptIdRoute
  '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/text/$itemSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugTextItemSlugRoute
  '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/video/$itemSlug': typeof ProtectedProgramsProgramSlugModuleSlugLessonSlugVideoItemSlugRoute
  '/_protected/community-hub/spaces/$id/modules/$moduleId/': typeof ProtectedCommunityHubSpacesIdModulesModuleIdIndexRoute
  '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdIndexRoute
  '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEmbedContentIdRoute
  '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEventContentIdRoute
  '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdFormContentIdRoute
  '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdGcsUploadContentIdRoute
  '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdPdfContentIdRoute
  '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdQuizContentIdRoute
  '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdResultsAttemptIdRoute
  '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdTextContentIdRoute
  '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdVideoContentIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/account'
    | '/apps'
    | '/auth/callback'
    | '/auth/cancel-email-change'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/magic-link'
    | '/auth/reset-password'
    | '/auth/sso'
    | '/auth/update-password'
    | '/auth/verify-email-change'
    | '/orders/$orderNo'
    | '/payment-plans/$paymentPlanId'
    | '/subscriptions/$subscriptionNo'
    | '/contact'
    | '/programs/$programSlug'
    | '/billing'
    | '/community-hub'
    | '/media'
    | '/programs'
    | '/community-hub/spaces/$id'
    | '/programs/$programSlug/$moduleSlug'
    | '/programs/$programSlug/'
    | '/programs/$programSlug/$moduleSlug/$lessonSlug'
    | '/community-hub/spaces/$id/community'
    | '/programs/$programSlug/embed/$itemSlug'
    | '/programs/$programSlug/event/$itemSlug'
    | '/programs/$programSlug/form/$itemSlug'
    | '/programs/$programSlug/gcs-upload/$itemSlug'
    | '/programs/$programSlug/pdf/$itemSlug'
    | '/programs/$programSlug/quiz/$itemSlug'
    | '/programs/$programSlug/results/$attemptId'
    | '/programs/$programSlug/text/$itemSlug'
    | '/programs/$programSlug/video/$itemSlug'
    | '/community-hub/$programSlug/$feedSlug'
    | '/community-hub/spaces/$id/'
    | '/programs/$programSlug/$moduleSlug/'
    | '/community-hub/$programSlug/$feedSlug/posts/$postId'
    | '/community-hub/spaces/$id/posts/$postId'
    | '/community-hub/spaces/$id/lesson'
    | '/community-hub/spaces/$id/modules'
    | '/programs/$programSlug/$moduleSlug/$lessonSlug/'
    | '/programs/$programSlug/$moduleSlug/$lessonSlug/embed/$itemSlug'
    | '/programs/$programSlug/$moduleSlug/$lessonSlug/event/$itemSlug'
    | '/programs/$programSlug/$moduleSlug/$lessonSlug/form/$itemSlug'
    | '/programs/$programSlug/$moduleSlug/$lessonSlug/gcs-upload/$itemSlug'
    | '/programs/$programSlug/$moduleSlug/$lessonSlug/pdf/$itemSlug'
    | '/programs/$programSlug/$moduleSlug/$lessonSlug/quiz/$itemSlug'
    | '/programs/$programSlug/$moduleSlug/$lessonSlug/results/$attemptId'
    | '/programs/$programSlug/$moduleSlug/$lessonSlug/text/$itemSlug'
    | '/programs/$programSlug/$moduleSlug/$lessonSlug/video/$itemSlug'
    | '/community-hub/spaces/$id/modules/$moduleId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/account'
    | '/apps'
    | '/auth/callback'
    | '/auth/cancel-email-change'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/magic-link'
    | '/auth/reset-password'
    | '/auth/sso'
    | '/auth/update-password'
    | '/auth/verify-email-change'
    | '/orders/$orderNo'
    | '/payment-plans/$paymentPlanId'
    | '/subscriptions/$subscriptionNo'
    | '/contact'
    | '/billing'
    | '/community-hub'
    | '/media'
    | '/programs'
    | '/programs/$programSlug'
    | '/community-hub/spaces/$id/community'
    | '/programs/$programSlug/embed/$itemSlug'
    | '/programs/$programSlug/event/$itemSlug'
    | '/programs/$programSlug/form/$itemSlug'
    | '/programs/$programSlug/gcs-upload/$itemSlug'
    | '/programs/$programSlug/pdf/$itemSlug'
    | '/programs/$programSlug/quiz/$itemSlug'
    | '/programs/$programSlug/results/$attemptId'
    | '/programs/$programSlug/text/$itemSlug'
    | '/programs/$programSlug/video/$itemSlug'
    | '/community-hub/$programSlug/$feedSlug'
    | '/community-hub/spaces/$id'
    | '/programs/$programSlug/$moduleSlug'
    | '/community-hub/$programSlug/$feedSlug/posts/$postId'
    | '/community-hub/spaces/$id/posts/$postId'
    | '/community-hub/spaces/$id/lesson'
    | '/community-hub/spaces/$id/modules'
    | '/programs/$programSlug/$moduleSlug/$lessonSlug'
    | '/programs/$programSlug/$moduleSlug/$lessonSlug/embed/$itemSlug'
    | '/programs/$programSlug/$moduleSlug/$lessonSlug/event/$itemSlug'
    | '/programs/$programSlug/$moduleSlug/$lessonSlug/form/$itemSlug'
    | '/programs/$programSlug/$moduleSlug/$lessonSlug/gcs-upload/$itemSlug'
    | '/programs/$programSlug/$moduleSlug/$lessonSlug/pdf/$itemSlug'
    | '/programs/$programSlug/$moduleSlug/$lessonSlug/quiz/$itemSlug'
    | '/programs/$programSlug/$moduleSlug/$lessonSlug/results/$attemptId'
    | '/programs/$programSlug/$moduleSlug/$lessonSlug/text/$itemSlug'
    | '/programs/$programSlug/$moduleSlug/$lessonSlug/video/$itemSlug'
    | '/community-hub/spaces/$id/modules/$moduleId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId'
  id:
    | '__root__'
    | '/'
    | '/_protected'
    | '/account'
    | '/apps'
    | '/auth/callback'
    | '/auth/cancel-email-change'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/magic-link'
    | '/auth/reset-password'
    | '/auth/sso'
    | '/auth/update-password'
    | '/auth/verify-email-change'
    | '/orders/$orderNo'
    | '/payment-plans/$paymentPlanId'
    | '/subscriptions/$subscriptionNo'
    | '/contact/'
    | '/_protected/programs/$programSlug'
    | '/_protected/billing/'
    | '/_protected/community-hub/'
    | '/_protected/media/'
    | '/_protected/programs/'
    | '/_protected/community-hub/spaces/$id'
    | '/_protected/programs/$programSlug/$moduleSlug'
    | '/_protected/programs/$programSlug/'
    | '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug'
    | '/_protected/community-hub/spaces/$id/community'
    | '/_protected/programs/$programSlug/embed/$itemSlug'
    | '/_protected/programs/$programSlug/event/$itemSlug'
    | '/_protected/programs/$programSlug/form/$itemSlug'
    | '/_protected/programs/$programSlug/gcs-upload/$itemSlug'
    | '/_protected/programs/$programSlug/pdf/$itemSlug'
    | '/_protected/programs/$programSlug/quiz/$itemSlug'
    | '/_protected/programs/$programSlug/results/$attemptId'
    | '/_protected/programs/$programSlug/text/$itemSlug'
    | '/_protected/programs/$programSlug/video/$itemSlug'
    | '/_protected/community-hub/$programSlug/$feedSlug/'
    | '/_protected/community-hub/spaces/$id/'
    | '/_protected/programs/$programSlug/$moduleSlug/'
    | '/_protected/community-hub/$programSlug/$feedSlug/posts/$postId'
    | '/_protected/community-hub/spaces/$id/posts/$postId'
    | '/_protected/community-hub/spaces/$id/lesson/'
    | '/_protected/community-hub/spaces/$id/modules/'
    | '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/'
    | '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/embed/$itemSlug'
    | '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/event/$itemSlug'
    | '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/form/$itemSlug'
    | '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/gcs-upload/$itemSlug'
    | '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/pdf/$itemSlug'
    | '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/quiz/$itemSlug'
    | '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/results/$attemptId'
    | '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/text/$itemSlug'
    | '/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/video/$itemSlug'
    | '/_protected/community-hub/spaces/$id/modules/$moduleId/'
    | '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/'
    | '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId'
    | '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId'
    | '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId'
    | '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId'
    | '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId'
    | '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId'
    | '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId'
    | '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId'
    | '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProtectedRouteRoute: typeof ProtectedRouteRouteWithChildren
  AccountRoute: typeof AccountRoute
  AppsRoute: typeof AppsRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthCancelEmailChangeRoute: typeof AuthCancelEmailChangeRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthMagicLinkRoute: typeof AuthMagicLinkRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSsoRoute: typeof AuthSsoRoute
  AuthUpdatePasswordRoute: typeof AuthUpdatePasswordRoute
  AuthVerifyEmailChangeRoute: typeof AuthVerifyEmailChangeRoute
  OrdersOrderNoRoute: typeof OrdersOrderNoRoute
  PaymentPlansPaymentPlanIdRoute: typeof PaymentPlansPaymentPlanIdRoute
  SubscriptionsSubscriptionNoRoute: typeof SubscriptionsSubscriptionNoRoute
  ContactIndexRoute: typeof ContactIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProtectedRouteRoute: ProtectedRouteRouteWithChildren,
  AccountRoute: AccountRoute,
  AppsRoute: AppsRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthCancelEmailChangeRoute: AuthCancelEmailChangeRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthMagicLinkRoute: AuthMagicLinkRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSsoRoute: AuthSsoRoute,
  AuthUpdatePasswordRoute: AuthUpdatePasswordRoute,
  AuthVerifyEmailChangeRoute: AuthVerifyEmailChangeRoute,
  OrdersOrderNoRoute: OrdersOrderNoRoute,
  PaymentPlansPaymentPlanIdRoute: PaymentPlansPaymentPlanIdRoute,
  SubscriptionsSubscriptionNoRoute: SubscriptionsSubscriptionNoRoute,
  ContactIndexRoute: ContactIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_protected",
        "/account",
        "/apps",
        "/auth/callback",
        "/auth/cancel-email-change",
        "/auth/forgot-password",
        "/auth/login",
        "/auth/magic-link",
        "/auth/reset-password",
        "/auth/sso",
        "/auth/update-password",
        "/auth/verify-email-change",
        "/orders/$orderNo",
        "/payment-plans/$paymentPlanId",
        "/subscriptions/$subscriptionNo",
        "/contact/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_protected": {
      "filePath": "_protected/route.tsx",
      "children": [
        "/_protected/programs/$programSlug",
        "/_protected/billing/",
        "/_protected/community-hub/",
        "/_protected/media/",
        "/_protected/programs/",
        "/_protected/community-hub/spaces/$id",
        "/_protected/community-hub/$programSlug/$feedSlug/",
        "/_protected/community-hub/$programSlug/$feedSlug/posts/$postId"
      ]
    },
    "/account": {
      "filePath": "account.tsx"
    },
    "/apps": {
      "filePath": "apps.tsx"
    },
    "/auth/callback": {
      "filePath": "auth/callback.tsx"
    },
    "/auth/cancel-email-change": {
      "filePath": "auth/cancel-email-change.tsx"
    },
    "/auth/forgot-password": {
      "filePath": "auth/forgot-password.tsx"
    },
    "/auth/login": {
      "filePath": "auth/login.tsx"
    },
    "/auth/magic-link": {
      "filePath": "auth/magic-link.tsx"
    },
    "/auth/reset-password": {
      "filePath": "auth/reset-password.tsx"
    },
    "/auth/sso": {
      "filePath": "auth/sso.tsx"
    },
    "/auth/update-password": {
      "filePath": "auth/update-password.tsx"
    },
    "/auth/verify-email-change": {
      "filePath": "auth/verify-email-change.tsx"
    },
    "/orders/$orderNo": {
      "filePath": "orders/$orderNo.tsx"
    },
    "/payment-plans/$paymentPlanId": {
      "filePath": "payment-plans/$paymentPlanId.tsx"
    },
    "/subscriptions/$subscriptionNo": {
      "filePath": "subscriptions/$subscriptionNo.tsx"
    },
    "/contact/": {
      "filePath": "contact/index.tsx"
    },
    "/_protected/programs/$programSlug": {
      "filePath": "_protected/programs/$programSlug/route.tsx",
      "parent": "/_protected",
      "children": [
        "/_protected/programs/$programSlug/$moduleSlug",
        "/_protected/programs/$programSlug/",
        "/_protected/programs/$programSlug/embed/$itemSlug",
        "/_protected/programs/$programSlug/event/$itemSlug",
        "/_protected/programs/$programSlug/form/$itemSlug",
        "/_protected/programs/$programSlug/gcs-upload/$itemSlug",
        "/_protected/programs/$programSlug/pdf/$itemSlug",
        "/_protected/programs/$programSlug/quiz/$itemSlug",
        "/_protected/programs/$programSlug/results/$attemptId",
        "/_protected/programs/$programSlug/text/$itemSlug",
        "/_protected/programs/$programSlug/video/$itemSlug"
      ]
    },
    "/_protected/billing/": {
      "filePath": "_protected/billing/index.tsx",
      "parent": "/_protected"
    },
    "/_protected/community-hub/": {
      "filePath": "_protected/community-hub/index.tsx",
      "parent": "/_protected"
    },
    "/_protected/media/": {
      "filePath": "_protected/media/index.tsx",
      "parent": "/_protected"
    },
    "/_protected/programs/": {
      "filePath": "_protected/programs/index.tsx",
      "parent": "/_protected"
    },
    "/_protected/community-hub/spaces/$id": {
      "filePath": "_protected/community-hub/spaces/$id/route.tsx",
      "parent": "/_protected",
      "children": [
        "/_protected/community-hub/spaces/$id/community",
        "/_protected/community-hub/spaces/$id/",
        "/_protected/community-hub/spaces/$id/posts/$postId",
        "/_protected/community-hub/spaces/$id/lesson/",
        "/_protected/community-hub/spaces/$id/modules/",
        "/_protected/community-hub/spaces/$id/modules/$moduleId/",
        "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/",
        "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId",
        "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId",
        "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId",
        "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId",
        "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId",
        "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId",
        "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId",
        "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId",
        "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId"
      ]
    },
    "/_protected/programs/$programSlug/$moduleSlug": {
      "filePath": "_protected/programs/$programSlug/$moduleSlug/route.tsx",
      "parent": "/_protected/programs/$programSlug",
      "children": [
        "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug",
        "/_protected/programs/$programSlug/$moduleSlug/"
      ]
    },
    "/_protected/programs/$programSlug/": {
      "filePath": "_protected/programs/$programSlug/index.tsx",
      "parent": "/_protected/programs/$programSlug"
    },
    "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug": {
      "filePath": "_protected/programs/$programSlug/$moduleSlug/$lessonSlug/route.tsx",
      "parent": "/_protected/programs/$programSlug/$moduleSlug",
      "children": [
        "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/",
        "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/embed/$itemSlug",
        "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/event/$itemSlug",
        "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/form/$itemSlug",
        "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/gcs-upload/$itemSlug",
        "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/pdf/$itemSlug",
        "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/quiz/$itemSlug",
        "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/results/$attemptId",
        "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/text/$itemSlug",
        "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/video/$itemSlug"
      ]
    },
    "/_protected/community-hub/spaces/$id/community": {
      "filePath": "_protected/community-hub/spaces/$id/community.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/programs/$programSlug/embed/$itemSlug": {
      "filePath": "_protected/programs/$programSlug/embed/$itemSlug.tsx",
      "parent": "/_protected/programs/$programSlug"
    },
    "/_protected/programs/$programSlug/event/$itemSlug": {
      "filePath": "_protected/programs/$programSlug/event/$itemSlug.tsx",
      "parent": "/_protected/programs/$programSlug"
    },
    "/_protected/programs/$programSlug/form/$itemSlug": {
      "filePath": "_protected/programs/$programSlug/form/$itemSlug.tsx",
      "parent": "/_protected/programs/$programSlug"
    },
    "/_protected/programs/$programSlug/gcs-upload/$itemSlug": {
      "filePath": "_protected/programs/$programSlug/gcs-upload/$itemSlug.tsx",
      "parent": "/_protected/programs/$programSlug"
    },
    "/_protected/programs/$programSlug/pdf/$itemSlug": {
      "filePath": "_protected/programs/$programSlug/pdf/$itemSlug.tsx",
      "parent": "/_protected/programs/$programSlug"
    },
    "/_protected/programs/$programSlug/quiz/$itemSlug": {
      "filePath": "_protected/programs/$programSlug/quiz/$itemSlug.tsx",
      "parent": "/_protected/programs/$programSlug"
    },
    "/_protected/programs/$programSlug/results/$attemptId": {
      "filePath": "_protected/programs/$programSlug/results/$attemptId.tsx",
      "parent": "/_protected/programs/$programSlug"
    },
    "/_protected/programs/$programSlug/text/$itemSlug": {
      "filePath": "_protected/programs/$programSlug/text/$itemSlug.tsx",
      "parent": "/_protected/programs/$programSlug"
    },
    "/_protected/programs/$programSlug/video/$itemSlug": {
      "filePath": "_protected/programs/$programSlug/video/$itemSlug.tsx",
      "parent": "/_protected/programs/$programSlug"
    },
    "/_protected/community-hub/$programSlug/$feedSlug/": {
      "filePath": "_protected/community-hub/$programSlug/$feedSlug/index.tsx",
      "parent": "/_protected"
    },
    "/_protected/community-hub/spaces/$id/": {
      "filePath": "_protected/community-hub/spaces/$id/index.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/programs/$programSlug/$moduleSlug/": {
      "filePath": "_protected/programs/$programSlug/$moduleSlug/index.tsx",
      "parent": "/_protected/programs/$programSlug/$moduleSlug"
    },
    "/_protected/community-hub/$programSlug/$feedSlug/posts/$postId": {
      "filePath": "_protected/community-hub/$programSlug/$feedSlug/posts/$postId.tsx",
      "parent": "/_protected"
    },
    "/_protected/community-hub/spaces/$id/posts/$postId": {
      "filePath": "_protected/community-hub/spaces/$id/posts/$postId.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/lesson/": {
      "filePath": "_protected/community-hub/spaces/$id/lesson/index.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/modules/": {
      "filePath": "_protected/community-hub/spaces/$id/modules/index.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/": {
      "filePath": "_protected/programs/$programSlug/$moduleSlug/$lessonSlug/index.tsx",
      "parent": "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug"
    },
    "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/embed/$itemSlug": {
      "filePath": "_protected/programs/$programSlug/$moduleSlug/$lessonSlug/embed/$itemSlug.tsx",
      "parent": "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug"
    },
    "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/event/$itemSlug": {
      "filePath": "_protected/programs/$programSlug/$moduleSlug/$lessonSlug/event/$itemSlug.tsx",
      "parent": "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug"
    },
    "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/form/$itemSlug": {
      "filePath": "_protected/programs/$programSlug/$moduleSlug/$lessonSlug/form/$itemSlug.tsx",
      "parent": "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug"
    },
    "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/gcs-upload/$itemSlug": {
      "filePath": "_protected/programs/$programSlug/$moduleSlug/$lessonSlug/gcs-upload/$itemSlug.tsx",
      "parent": "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug"
    },
    "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/pdf/$itemSlug": {
      "filePath": "_protected/programs/$programSlug/$moduleSlug/$lessonSlug/pdf/$itemSlug.tsx",
      "parent": "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug"
    },
    "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/quiz/$itemSlug": {
      "filePath": "_protected/programs/$programSlug/$moduleSlug/$lessonSlug/quiz/$itemSlug.tsx",
      "parent": "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug"
    },
    "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/results/$attemptId": {
      "filePath": "_protected/programs/$programSlug/$moduleSlug/$lessonSlug/results/$attemptId.tsx",
      "parent": "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug"
    },
    "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/text/$itemSlug": {
      "filePath": "_protected/programs/$programSlug/$moduleSlug/$lessonSlug/text/$itemSlug.tsx",
      "parent": "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug"
    },
    "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/video/$itemSlug": {
      "filePath": "_protected/programs/$programSlug/$moduleSlug/$lessonSlug/video/$itemSlug.tsx",
      "parent": "/_protected/programs/$programSlug/$moduleSlug/$lessonSlug"
    },
    "/_protected/community-hub/spaces/$id/modules/$moduleId/": {
      "filePath": "_protected/community-hub/spaces/$id/modules/$moduleId/index.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/": {
      "filePath": "_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/index.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId": {
      "filePath": "_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId": {
      "filePath": "_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId": {
      "filePath": "_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId": {
      "filePath": "_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId": {
      "filePath": "_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId": {
      "filePath": "_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId": {
      "filePath": "_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId": {
      "filePath": "_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId": {
      "filePath": "_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    }
  }
}
ROUTE_MANIFEST_END */
